/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

import type { UserDetail, UserRole } from "./user-types"

export class UserDetailStore {
    userDetail: UserDetail | null = null
    userDetailRoles: UserRole[] = []

    constructor() {
        makeAutoObservable(this, {
            setUserDetail: true,
            setUserDetailRoles: true
        })
    }

    // Actions
    setUserDetail(user: UserDetail): void {
        this.userDetail = user
    }

    setUserDetailRoles(userRoles: UserRole[]): void {
        this.userDetailRoles = userRoles
    }
}
